export { IResultAction, IResultActionError, IResultActionSuccess } from "./types";
export { createResultAction, isErrorAction, isSuccessAction, takeResultAction } from "./utils";
